import {
  Box,
  Paper,
  Typography,
  Grid,
  Hidden,
  Tooltip as GridTooltip,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect, useContext } from "react";
import { AppDataContext } from "../../../common/appContext";
import midSideMidDrill from "../../../icons/icons-NBAblue/side-mid-side.png";
import midSideMid from "../../../images/shooting_drills/SideMidSide.jpg";
import { DataGrid } from "@mui/x-data-grid";
import { PlayerProfileService } from "./../../../services/playerProfile.Service";
import ShootingDrillChart from "./ShootingDrillChart";
import { Video_baseUrl } from "../../../services/AzureStorage";
import JWPlayer from "./../../../sharedComponents/JWPlayer/JWPlayer";
import PlayerImg from "../../../images/novideo.png";
import PrimaryVideoImage from "../../../images/C3_B.png";
import SecondaryVideoImage from "../../../images/C3_G.png";
import CustomTooltip from "../../../common/CustomTooltip";

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import VideoJS from "../../../sharedComponents/videoPlayer/VideoJS";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontWeight: "500",
  },
  paperStyle: {
    margin: "15px",
    padding: "15px",
  },
  radarChart: {
    [theme.breakpoints.up("xs")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: "-50px",
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: "-50px",
    },
  },
  btnselected: {
    backgroundColor: "#C8102E", //"#1d428a",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#C8102E",
    },
  },
  btnunselected: {
    backgroundColor: "#707070",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#707070",
    },
  },
}));

export default function MidSideMidDrill(props) {
  const { playerID, styles, EventId } = props;
  var selectedEventId = EventId; //useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  const { user } = useContext(AppDataContext);
  const useParentStyles = makeStyles((theme) => styles);
  const parentClasses = useParentStyles();
  const classes = useStyles();
  const [resultsData, setResultsData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [imagevideo, setimagevideo] = useState("");
  const [filename, setFilename] = useState("");

  //#Video Angles Data holders
  const [midSideMidVideoAngle, setMidSideMidVideoAngle] = useState("primary");
  const [midSideMidResultSet, setMidSideMidResultSet] = useState({});

  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 768 ? 1 : "none"
  );

  const labels = [
    "Center Half to Top Key",
    "Right Side Line to Right Wing",
    "Left Side Line to Left Wing",
  ];

  const chartLabels = [
    "Center Half to Top Key",
    ["Right Side Line", "to", "Right Wing"],
    ["Left Side Line", "to", "Left Wing"],
  ];

  const regions = {
    CenterHalfToTopKey: labels[0],
    RightSidelineToRightWing: labels[1],
    LeftSidelineToLeftWing: labels[2],
  };
  useEffect(() => {
    setEventId(selectedEventId);
  }, [selectedEventId]);
  useEffect(() => {
    PlayerProfileService.getShootingDrillSummaryByPlayerId(
      eventId,
      307,
      playerID,
      user?.loginID
    ).then((response) => {
      let gridData = [],
        chart = [],
        apiData = [],
        maxValue = 0;
      if (response.data.length) {
        //#Store result set
        setMidSideMidResultSet(response.data[0]);

        var data = response.data[0].jsonData;
        if (data !== null) {
          var data1 = JSON.parse(data);
          setimagevideo(data1.thumbnail);
        }
        setFilename(response.data[0].fileName);
      }
      response.data.forEach((elem, i) => {
        if (labels.includes(regions[elem.region])) {
          apiData.push(regions[elem.region]);
          maxValue = i + 1;
          gridData.push({
            id: i + 1,
            region: regions[elem.region],
            result: `${elem.noOfMade} / ${elem.maxCount}`,
            percentage: elem.percentage,
          });
        }
      });
      const difference = labels.filter((x) => !apiData.includes(x));
      difference.forEach((elem, i) => {
        gridData.push({
          id: maxValue + i + 1,
          region: elem,
          result: "--",
          percentage: "--",
        });
      });
      setResultsData(gridData);
      labels.forEach((elem) => {
        gridData.forEach((row) => {
          if (row.region === elem) {
            if (row.percentage === "--") {
              chart.push(0);
            } else {
              chart.push(row.percentage);
            }
          }
        });
      });
      setChartData(chart);
    });

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [eventId]);

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 768 ? 1 : "none");
  };

  const handleVideoAngleClick = (angleType) => {
    setMidSideMidVideoAngle(angleType);
    //console.log("spotUpResultSet", spotUpResultSet);
    const { name: primaryFileName, thumbnail: primaryThumbnail } = JSON.parse(
      midSideMidResultSet["jsonData"] || "{}"
    );

    const { name: secondaryFileName, thumbnail: secondaryThumbnail } =
      JSON.parse(midSideMidResultSet["secondaryJsonData"] || "{}");

    if (angleType === "secondary") {
      setFilename(secondaryFileName || "");
      setimagevideo(secondaryThumbnail || "");
    } else if (angleType === "primary") {
      setFilename(primaryFileName || "");
      setimagevideo(primaryThumbnail || "");
    }
  };
  return (
    <Paper elevation={5} className={classes.paperStyle}>
      <Box display="flex" justifyContent="center">
        <img
          alt="mid-side-mid-icon"
          src={midSideMidDrill}
          height={30}
          width={30}
          style={{
            marginRight: "5px",
          }}
        />
        <Typography
          noWrap
          color="primary"
          variant="subtitle1"
          className={classes.subtitle}
          sx={{ marginTop: "-5px", fontSize: "25px" }}
        >
          Mid Side Mid Drill
        </Typography>
      </Box>

      <Hidden lgUp>
        <Grid Container>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <Box
              mt={resultsData.length ? 1 : 2}
              className="spotupVideoPadding"
              sx={{
                border: "2px solid lightgrey",
                borderRadius: "5px",
              }}
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ my: 1 }}
              >
                <IconButton
                  size="small"
                  onClick={() => handleVideoAngleClick("primary")}
                  sx={{
                    backgroundColor:
                      midSideMidVideoAngle === "primary"
                        ? "rgba(29, 66, 138, 0.2)"
                        : "",
                  }}
                >
                  <CustomTooltip title="Primary Video" placement="top">
                    <img
                      alt="Primary Video"
                      src={
                        midSideMidVideoAngle === "primary"
                          ? PrimaryVideoImage
                          : SecondaryVideoImage
                      }
                      width="30"
                      height="30"
                    />
                  </CustomTooltip>
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleVideoAngleClick("secondary")}
                  sx={{
                    backgroundColor:
                      midSideMidVideoAngle === "secondary"
                        ? "rgba(29, 66, 138, 0.2)"
                        : "",
                  }}
                >
                  <CustomTooltip title="Secondary Video" placement="top">
                    <img
                      alt="Secondary Video"
                      src={
                        midSideMidVideoAngle === "secondary"
                          ? PrimaryVideoImage
                          : SecondaryVideoImage
                      }
                      width="30"
                      height="30"
                    />
                  </CustomTooltip>
                </IconButton>
              </Box>
              <Box
                justifyContent="center"
                display="flex"
                className="spotupShootingJWPlayer"
              >
                {filename === null || filename === "" ? (
                  <img
                    alt="no-video-found"
                    src={PlayerImg}
                    className="noVideoImage"
                  />
                ) : (
                  <VideoJS
                    fileURL={Video_baseUrl(filename)}
                    image={Video_baseUrl(imagevideo)}
                    isAutoplay={false}
                    id="midsidemidedrillVideo"
                    fileName={filename}
                    isSlowMo={true}
                    isDownload={true}
                  />
                )}
              </Box>
            </Box>
          </Grid>{" "}
        </Grid>
      </Hidden>
      <Hidden lgDown>
        {" "}
        <Box
          sx={{
            border: "2px solid lightgrey",
            borderRadius: "5px",
            maxWidth: "150px",
          }}
        >
          <img alt="mid-side-mid-drill" src={midSideMid} width="100%" />
        </Box>
      </Hidden>
      <Box sx={{ margin: "15px 0px 0px 5px" }}>
        <Grid
          container
          justifyContent={resultsData.length ? "space-between" : "left"}
        >
          {" "}
          <Hidden lgUp>
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <Box
                sx={{
                  border: "2px solid lightgrey",
                  borderRadius: "5px",
                  maxWidth: "200px",
                }}
              >
                <img alt="mid-side-mid-drill" src={midSideMid} width="100%" />
              </Box>
            </Grid>
          </Hidden>
          <Grid item lg={4} md={8} sm={12} xs={12}>
            <Typography noWrap color="primary" variant="subtitle2">
              Results
            </Typography>
            <Box sx={{ height: "250px", marginTop: "10px" }}>
              <DataGrid
                className={parentClasses.gridRoot}
                pageSize={styles.gridConfig.pageSize}
                rowHeight={styles.gridConfig.rowHeight}
                headerHeight={styles.gridConfig.headerHeight}
                hideFooterPagination={true}
                hideFooter={true}
                rows={resultsData}
                columns={[
                  { field: "id", hide: true, flex: 1 },
                  {
                    field: "region",
                    headerName: "Region",
                    width: 200,
                    renderCell: (params) => {
                      return (
                        <GridTooltip
                          style={{ cursor: "pointer" }}
                          title={params.value}
                        >
                          <span>{params.value}</span>
                        </GridTooltip>
                      );
                    },
                  },
                  {
                    field: "result",
                    headerName: "Result",
                    width: 110,
                    flex: columnFlex,
                  },
                  {
                    field: "percentage",
                    headerName: "Percentage",
                    width: 120,
                    flex: columnFlex,
                  },
                ]}
                disableSelectionOnClick
                disableColumnSelector
                getCellClassName={(params) => {
                  if (params.field !== "actions") {
                    return styles.gridCellClassName;
                  }
                }}
                components={{
                  NoRowsOverlay: () => (
                    <Box className={parentClasses.noRowsOverlay}>No Rows</Box>
                  ),
                  NoResultsOverlay: () => (
                    <Box className={parentClasses.noRowsOverlay}>
                      No Results Found
                    </Box>
                  ),
                }}
              />
            </Box>
          </Grid>
          {resultsData.length ? (
            <Grid
              item
              lg={3}
              md={12}
              sm={12}
              xs={12}
              className={classes.radarChart}
            >
              <Box sx={{ maxWidth: "500px", margin: "0 auto" }}>
                <ShootingDrillChart
                  labels={labels}
                  chartData={chartData}
                  label={"Percentages"}
                />
              </Box>
            </Grid>
          ) : (
            ""
          )}
          <Hidden lgDown>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <Box
                mt={resultsData.length ? 0 : 2}
                sx={{
                  padding: "15px",
                  border: "2px solid lightgrey",
                  borderRadius: "5px",
                }}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ my: 1 }}
                >
                  <IconButton
                    size="small"
                    onClick={() => handleVideoAngleClick("primary")}
                    sx={{
                      backgroundColor:
                        midSideMidVideoAngle === "primary"
                          ? "rgba(29, 66, 138, 0.2)"
                          : "",
                    }}
                  >
                    <CustomTooltip title="Primary Video" placement="top">
                      <img
                        alt="Primary Video"
                        src={
                          midSideMidVideoAngle === "primary"
                            ? PrimaryVideoImage
                            : SecondaryVideoImage
                        }
                        width="30"
                        height="30"
                      />
                    </CustomTooltip>
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleVideoAngleClick("secondary")}
                    sx={{
                      backgroundColor:
                        midSideMidVideoAngle === "secondary"
                          ? "rgba(29, 66, 138, 0.2)"
                          : "",
                    }}
                  >
                    <CustomTooltip title="Secondary Video" placement="top">
                      <img
                        alt="Secondary Video"
                        src={
                          midSideMidVideoAngle === "secondary"
                            ? PrimaryVideoImage
                            : SecondaryVideoImage
                        }
                        width="30"
                        height="30"
                      />
                    </CustomTooltip>
                  </IconButton>
                </Box>
                <Box
                  justifyContent="center"
                  display="flex"
                  className="spotupShootingJWPlayer"
                >
                  {filename === null || filename === "" ? (
                    <img
                      alt="no-video-found"
                      src={PlayerImg}
                      className="noVideoImage"
                    />
                  ) : (
                    <VideoJS
                      fileURL={Video_baseUrl(filename)}
                      image={Video_baseUrl(imagevideo)}
                      isAutoplay={false}
                      id="midsidemidedrillVideo"
                      fileName={filename}
                      isSlowMo={true}
                      isDownload={true}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
          </Hidden>
        </Grid>
      </Box>
    </Paper>
  );
}
